<script>
import { mapGetters } from 'vuex'

export default {
  name: 'GoogleOneTap',

  head() {
    if (!this.googleOneTapClientId) {
      return
    }

    return {
      script: [
        {
          vmid: 'googleOneTap',
          src: '//accounts.google.com/gsi/client',
          async: true,
          defer: true,
          callback: () => {
            this.setupGoogleOneTap()
          }
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      googleOneTapClientId: 'globalConfig/googleOneTapClientId'
    })
  },

  methods: {
    setupGoogleOneTap() {
      window.google.accounts.id.initialize({
        client_id: this.googleOneTapClientId,
        cancel_on_tap_outside: false,
        callback: this.oneTapLogin
      })
      window.google.accounts.id.prompt()
    },

    oneTapLogin(response) {
      this.$authManager.socialLogin('googleOneTap', response.credential)
    }
  },

  render() {
    return null
  }
}
</script>

<style lang="scss">
@include tablet {
  #credential_picker_container {
    top: 35px !important;
    right: 5px !important;
  }
}
</style>
